<template>
    <div>
        <login class="login-wrapper" v-if="!user" />
        <div class="page-header ion-padding-vertical">
            <ion-text color="secondary">
                <h1>{{ $t('home.title') }}</h1>
            </ion-text>
            <img src="@/assets/title-icon.png" />
        </div>
        <ion-row v-if="!isLoading" class="users-wrapper ion-margin-top">
            <ion-col v-for="user in users.slice(0, 4)" :key="user.id" size="3">
                <user-card :user="user" />
            </ion-col>
        </ion-row>
        <div class="spinner-wrapper ion-margin-top ion-margin-bottom" v-if="isLoading">
            <ion-spinner class="ion-margin-top ion-margin-bottom" color="primary"></ion-spinner>
        </div>
        <ion-button class="more-btn ion-margin-top ion-margin-bottom" @click="goToSearch" color="secondary" shape="round">
            {{ $t('master.more') }}
        </ion-button>
        <ad-leaderboard />
        <div class="safe-hands ion-padding-bottom">
            <div class="page-header ion-padding-vertical">
                <ion-text color="secondary">
                    <h1>{{ $t('home.safeHands') }}</h1>
                </ion-text>
                <img src="@/assets/title-icon.png" />
            </div>
            <ion-row>
                <ion-col size="4.5">
                    <img class="img-secure ion-float-end ion-margin-end ion-margin-top" src="@/assets/secure.png" />
                </ion-col>
                <ion-col size="7.5">
                    <p v-html="$t('home.safeHandsText')" class="safe-hands-text ion-text-start">
                        {{ $t('home.safeHandsText') }}
                    </p>
                </ion-col>
            </ion-row>
        </div>
        <div class="get-app ion-padding-top">
            <ion-row class="get-app-wrapper">
                <ion-col size="7" class="ion-text-start get-app-text">
                    <h1 class="ion-margin-start">{{ $t('home.getApp') }}</h1>
                    <p class="ion-margin-start ion-margin-top">{{ $t('home.getAppText') }}</p>
                    <ion-row>
                        <ion-col class="ion-margin-start" size="4">
                            <img class="btn-playstore" src="@/assets/play-store.png" @click="goToPlaystore" />
                        </ion-col>
                        <ion-col class="ion-margin-start" size="4">
                            <img class="btn-playstore" src="@/assets/app-store.png" @click="goToAppleStore" />
                        </ion-col>
                    </ion-row>
                </ion-col>
                <ion-col size="5">
                    <img src="@/assets/phone-mockups.png" />
                </ion-col>
            </ion-row>
        </div>
    </div>
</template>

<script>
import Login from '@/views/auth/Login.vue'
import PageHeader from '@/components/PageHeader.vue'
import AxiosController from '@/controllers/AxiosController'
import { mapGetters } from 'vuex'
import UserCard from '@/components/UserCard'
import AdLeaderboard from '@/components/AdLeaderboard'

export default {
    name: 'HomeDesktop',
    components: { Login, PageHeader, UserCard, AdLeaderboard },
    computed: mapGetters(['user']),
    data() {
        return {
            users: [],
            isLoading: true
        }
    },
    mounted() {
        AxiosController.get('/search').then(res => {
            this.users = res.data
            this.isLoading = false
        })
    },
    methods: {
        goToSearch() {
            this.$router.push('/search')
        },
        goToPlaystore() {
            window.open('https://play.google.com/store/apps/details?id=com.sharekomry.androidapp')
        },
        goToAppleStore() {
            window.open('https://apps.apple.com/app/sharekomry/id1510711758')
        }
    }
}
</script>

<style lang="scss" scoped>
.login-wrapper {
    width: 100%;
    margin: 0;
    overflow: hidden;
    background-size: cover;
}

.users-wrapper {
    // margin-top: 10vh;
    width: 70%;
    margin-left: 15%;
    margin-right: 15%;
}

.spinner-wrapper {
    min-height: 200px;
}

.safe-hands {
    width: 100%;
    background-color: #dbdada;
    margin-top: 10vh;

    .safe-hands-text {
        font-size: 20px;
        width: 60%;
    }

    .img-secure {
        width: 30%;
    }
}

.get-app-wrapper {
    padding-top: 8vh;
}

.get-app {
    width: 100%;
    background: linear-gradient(#92f0ae80, #70fa9a80), url('~@/assets/chat-bg.jpg');
    background-size: cover;
    position: relative;
    padding: 0 20%;

    .get-app-text {
        margin-top: 15vh;
    }
}

h1 {
    color: #114f64;
    font-size: 35px;
    font-weight: 700;
}

.btn-playstore {
    cursor: pointer;
}
</style>
